import type { RouteLocationResolved } from 'vue-router'

import { ROUTE_NAMES } from '@/router/constants'
import type { GoogleSearchAPIResult } from '@/types/search'
import safeURLParse from '@/utils/safeURLParse'

import type { SearchGameResult, SearchGroupResult, SearchResults } from './types'

export const mapSearchApiResults = ({
    query,
    data,
    resolveRoute,
}: {
    query: string
    data: GoogleSearchAPIResult
    resolveRoute: (link: string) => RouteLocationResolved
}) => {
    const searchResult: SearchResults = {
        result: [],
        totalItems: 0,
        queryTerm: '',
    }
    const findByHru = (searchedItem: SearchGameResult | SearchGroupResult, hru: string) => {
        if (typeof searchedItem === 'object' && 'hru' in searchedItem) {
            return searchedItem.hru === hru
        }
        return false
    }
    const getClearTitle = (input: string): string => {
        if (!input) {
            return input
        }
        // return title without last text part in meta title "—– play on Playgama"
        return input.split(/\s[—–]\s/u)[0]?.trim() || ''
    }
    data.items?.forEach((item) => {
        const linkPath = safeURLParse(item.link)?.pathname

        if (!linkPath) {
            return
        }

        const route = resolveRoute(linkPath)

        if (route.name === ROUTE_NAMES.GAME_PAGE) {
            const applicationMeta = item.pagemap?.webapplication?.[0]
            const name = applicationMeta?.name || getClearTitle(item.title)
            const image = applicationMeta?.image || item.pagemap?.metatags?.[0]?.['og:image']

            if (name && image) {
                searchResult.result.push({
                    routeName: route.name,
                    gameHru: route.params.game as string,
                    image,
                    name,
                    htmlTitle: item.htmlTitle,
                })
            }
        } else if (
            route.name === ROUTE_NAMES.CATEGORY ||
            route.name === ROUTE_NAMES.TAG ||
            route.name === ROUTE_NAMES.SERIES
        ) {
            const name = item.pagemap?.webapplication?.[0]?.name || item.title?.split('|')[0]?.trim()
            if (name) {
                const hru = route.params.hru as string
                if (!searchResult.result.find((i) => findByHru(i, hru))) {
                    searchResult.result.push({
                        routeName: route.name,
                        hru,
                        name,
                        htmlTitle: item.htmlTitle,
                    })
                }
            }
        }
    })
    searchResult.totalItems = data.searchInformation.totalResults
    searchResult.queryTerm = query
    return searchResult
}
